import validator from 'validator';

export const required = value => (value ? undefined : 'Required');
export const email = value => (validator.isEmail(value) ? undefined : 'Invalid email');
export const phone = value => (validator.isMobilePhone(value.replace(/\s+/g, ''), 'any') ? undefined : 'Invalid phone number');



// WEBPACK FOOTER //
// ./src/validators.js